import React from 'react'

function InactivePill() {
  return (
    <span className="badge bg-light text-uppercase py-2 pe-4">
      <span style={{width: '8px', height: '8px'}} className="bg-danger rounded-circle me-2" />
      Inactive
    </span>
  )
}

export default InactivePill
